// bao migrate skip
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import BaseModel2 from "models/base-model2";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../factories/node-view-model";
import GenericListTab from "./../../factories/generic-list-tab";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import NodeViewModel from "./../../factories/node-view-model";
class ConfigurationItem300HardwareTab extends GenericListTab {
    ConfigurationItem: any;
    GridNodes = ko.observableArray([]);
    SelectedGridRow = ko.observable();
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 1000;
        this.ConfigurationItem = parent;
        this.SelectedGridRow.subscribe((value) => {
            this.ToggleToolbarButtons();
        });
        Bao["Templates"]["ConfigurationItem300Hardware"] = "\
        <tr data-bind=\"visible: Level == 0 || ($parent.Opened && RootOpened), click: Root.SelectGridRow, css: {'selected-blue': Root.SelectedGridRow() == $data} \">\
          <td data-bind='redrawIcons: Root.SelectedGridRow() == $data' style='white-space: nowrap'>\
             <i class=\"fa\" data-bind=\"style: {marginLeft: Level * 20 + 'px'}, click: Root.ShowChildren, css: Icon\"></i>\
             <span> {{Data.Sort}}</span>\
          </td>\
          <td data-bind=\"text: Data.ManufacturerTypeName\"></td>\
          <td data-bind=\"text: Data.PurchaseVendorName\"></td>\
          <td data-bind=\"text: Data.Price\"></td>\
          <td data-bind=\"text: Data.Amount\"></td>\
        </tr>\
        <!--ko template: { name: 'ConfigurationItem300Hardware', foreach: GridNodes } -->\
        <!-- /ko-->";
    }
    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            var key = ko.unwrap(button.ActionKey);
            var enabled = <KnockoutObservable<boolean>>(button.Enabled);
            if (key === this.PermissionEdit || key === this.PermissionRemove) {
                enabled(this.SelectedGridRow() != null);
            }
            else if (key === this.PermissionAdd) {
                enabled(true);
            }
            else if (key === "ConfigurationItem300HardwareTabAddNode") {
                enabled(this.SelectedGridRow() != null);
            }
        });
    }
    ;
    ControllerUrl = "ConfigurationItem300HardwareTab";
    CustomFilter() {
        return null;
    }
    SelectGridRow(item: any) {
        this.SelectedGridRow(item);
    }
    CustomToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case "ConfigurationItem300HardwareTabAddNode":
                //neuen Knoten anlegen
                this.AddNewNode(this.SelectedGridRow());
                break;
            case this.PermissionAdd:
                this.SelectedGridRow(null);
                this.Dialog.call(this, null);
                break;
            case this.PermissionEdit:
                if (this.SelectedGridRow() != null) {
                    if (this.SelectedGridRow())
                        this.Dialog(this.SelectedGridRow()["Data"]["ConfigurationItem300DetailId"]);
                    break;
                }
            case this.PermissionRemove:
                if (this.SelectedGridRow() != null) {
                    var ids = [];
                    var row = this.SelectedGridRow();
                    ids.push(row["Data"]["ConfigurationItem300DetailId"]);
                    this.BeforeRemove.call(this, ids).then((proceed) => {
                        if (proceed) {
                            this.Remove.call(this, ids);
                        }
                    });
                    break;
                }
        }
    };
    Remove(itemIds: string[]): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlRemove(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            ids: itemIds
        }), () => {
            this.TabPage.DirtyFlag(true);
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    AddNewNode(selectedRow) {
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItem300HardwareTab/AddNewNodeToHardware", JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.Parent.PrimaryKeyValue(),
            parentHardwareId: selectedRow.Data.ConfigurationItem300DetailId,
            id: selectedRow.ConfigurationItem300DetailId
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                item.ConfigurationItemId = this.ConfigurationItem.ConfigurationItemId();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(this.MinimizeEntity(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    ShowChildren(item) {
        if (item.Opened() === false) {
            item.Opened(true);
        }
        else {
            item.Opened(false);
        }
    }
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(), pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.GetNodeViewModels(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.Title(result.Definition.TabTitle);
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    GetNodeViewModels(models) {
        var arrayParent = [];
        for (let m in models) {
            if (models[m].DeleteDateHtml == null || models[m].DeleteDateHtml == "") {
                var node = new NodeViewModel(models[m].Sort, models[m].Level, models[m], models[m].ConfigurationItem300DetailId, models[m].OpenUrl, this);
                //childs für GridNodes an stelle m laden!
                node.GridNodes(this.GetChildNodes(models[m]));
                arrayParent.push(node);
            }
        }
        this.GridNodes(arrayParent);
    }
    GetChildNodes(parentmodel) {
        var array = [];
        for (let m in parentmodel.GridNodes) {
            if (parentmodel.GridNodes[m].DeleteDateHtml == null || parentmodel.GridNodes[m].DeleteDateHtml == "") {
                //alle Childs vom Model in Nodeviewmodels:
                var node = new NodeViewModel(parentmodel.GridNodes[m].Sort, parentmodel.GridNodes[m].Level, parentmodel.GridNodes[m], parentmodel.GridNodes[m].ConfigurationItem300DetailId, parentmodel.GridNodes[m].OpenUrl, this);
                array.push(node); //nodeViewModel Array zu aktuellem ParentNode
                node.GridNodes([]);
                //Childs für den aktuellen Node laden und hinzufügen:
                node.GridNodes(this.GetChildNodes(parentmodel.GridNodes[m]));
            }
        }
        //Childs zu dem Parent:
        return array;
    }
    Get(resetIndex = true): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("ConfigurationItem300HardwareTab/Get", JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(), pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.GetResponse) => {
            this.Models(result.Models);
            this.GetNodeViewModels(result.Models);
            this.TotalRows(result.TotalRows);
        }).always(() => {
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
            def.resolve();
        });
        return def.promise();
    }
    Refresh(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.Rollback().then(() => {
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    Dialog(id): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                item.ConfigurationItemId = this.ConfigurationItem.ConfigurationItemId();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(this.MinimizeEntity(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    Save(item): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("ConfigurationItem300HardwareTab/Save", JSON.stringify({
            sessionTabId: this.SessionTabId,
            model: item
        }), () => {
            this.SelectedGridRow(null);
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    MinimizeEntity(item) {
        var result = ko.map.toJS(item);
        delete result.ManufacturerItem;
        delete result.ManufacturerTypeItem;
        delete result.PurchaseVendorItem;
        return result;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default ConfigurationItem300HardwareTab;